import React, { ReactElement, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import pl from 'translations/pl.json';
import { PaymentPartial } from 'types/Payment';

import { PaymentNotificationContainer, PaymentNotificationBold } from './PaymentNotificationMobile.styles';
import {
  getDefaultPaymentNotificationSettings,
  NotificationProperties,
} from '../paymentNotification/NotificationProperties';
import withSelectedMethodContext from '../../hoc/withSelectedMethodContext';
import { ISelectedMethodContext } from '../../types/SelectedMethodContext';
import withContext from '../../hoc/withContext';

interface IPaymentNotification extends RouteComponentProps, Partial<ISelectedMethodContext>, Partial<IContext> {
  progress: number;
  payment: PaymentPartial;
  paymentMethodType: string | undefined;
}

function isNotificationVisibleForCurrentProgress(
  notificationProperties: NotificationProperties | undefined,
  progress: number
) {
  return (
    notificationProperties !== undefined &&
    progress >= notificationProperties.fromProgress &&
    progress <= notificationProperties.toProgress
  );
}

function PaymentNotification(props: IPaymentNotification): ReactElement {
  const { progress, payment, paymentMethodType, showPaymentNotification, isSelectedPaymentMethodDisabled } = props;
  const [notificationProperties, setNotificationProperties] = useState<NotificationProperties>();
  const [notificationVisible, setNotificationVisible] = useState<boolean>(false);

  useEffect(() => {
    const shouldDisplayNotificationForLevelZeroPayment =
      payment.selectedShowPaymentNotification && isSelectedPaymentMethodDisabled === false;

    const shouldDisplayDisabledPaymentMethodNotification =
      isSelectedPaymentMethodDisabled === true && !paymentMethodType;

    let isNotificationVisible = false;

    if (
      !shouldDisplayDisabledPaymentMethodNotification &&
      (shouldDisplayNotificationForLevelZeroPayment || showPaymentNotification)
    ) {
      const finalPaymentMethodType = paymentMethodType || payment.selectedPaymentMethodType || 'NO_PAYMENT_METHOD';
      const isLevelZero = payment.selectedPaymentMethodType != null;
      const newNotificationSettings = getDefaultPaymentNotificationSettings(finalPaymentMethodType, isLevelZero);
      setNotificationProperties(newNotificationSettings);
      isNotificationVisible = isNotificationVisibleForCurrentProgress(newNotificationSettings, progress);
    }
    setNotificationVisible(isNotificationVisible);
  }, [progress, paymentMethodType, payment, showPaymentNotification]);

  return (
    <PaymentNotificationContainer isVisible={notificationVisible} className="payment-notification__container">
      {notificationProperties && notificationProperties.notificationBold && (
        <>
          <PaymentNotificationBold className="statusbar__paymentNotificationBold">
            <FormattedMessage
              id={notificationProperties.notificationBold}
              defaultMessage={pl[notificationProperties.notificationBold]}
            />
          </PaymentNotificationBold>
        </>
      )}
    </PaymentNotificationContainer>
  );
}

export default withContext(withSelectedMethodContext(withRouter(PaymentNotification)));
